import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async createMacroActivity({ commit }, payload) {
    return Vue.axios
      .post(Vue.$url("macro-activity"), payload)
      .then((rsp) => {
        Vue.$log.debug("actvity type created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'MacroActivity', 1: payload.description }), { root: true });
        return rsp.data;
      })
  },

  async fetchMacroActivities({ commit }, { pId, vId, pvId }) {
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '') + '&pvId=' + (pvId || '');
    return Vue.axios.get(Vue.$url("macro-activity" + query))
      .then((rsp) => commit("SET_MACRO_ACTIVITIES", rsp.data))
  },

  async fetchNextMaxCode({ commit }, { pId, vId }) {
    Vue.$log.debug('loading macro activity next code for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '');
    return Vue.axios.get(Vue.$url("macro-activity/max-code" + query))
      .then((rsp) => {
        commit('SET_NEXT_SEQ_CODE', rsp.data);
        return rsp.data;
      })
  },

  async deleteMacroActivity({ commit }, payload) {
    Vue.$log.debug('trying to delete MacroActivity', payload.id);
    return Vue.axios
      .delete(Vue.$url("macro-activity/" + payload.id))
      .then(() => commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true }));
  },

  async updateMacroActivity({ commit }, payload) {
    return Vue.axios
      .put(Vue.$url("macro-activity/" + payload.id), payload)
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'MacroActivity', 1: payload.description }), { root: true });
        return rsp.data;
      });
  },

  async updateMacroActivityList({ commit }, payload) {
    Vue.$log.debug("Update xlsx", payload);

    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("pvId", payload.pvId);
    formData.append("resetOldValues", payload.resetOldValues);

    return await Vue.axios
      .post(Vue.$url(`macro-activity/import`), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((rsp) => {
        commit("mShowInfoMessage", i18n.t("common.upload"), { root: true });
        return rsp.data;
      });
  },
}